import { ComposableMap, Geographies } from "react-simple-maps";
import MapCountry from "./MapCountry";
import geoJson from "./countries-topojson.json";

export type CountryItem = {
    countryCode: string;
    color: string;
};

type MapProps = {
    countries: CountryItem[];
    hoveredCountryCodes?: string[];
    className?: string;
};

const Map = ({ hoveredCountryCodes, countries, className }: MapProps) => {
    return (
        <ComposableMap
            className={className}
            projection="geoMercator"
            projectionConfig={{
                center: [5, 42],
                scale: 135,
            }}
            transform=""
            height={600}
            width={850}
        >
            <Geographies geography={geoJson}>
                {({ geographies }) =>
                    geographies.map((geo) => (
                        <MapCountry
                            key={geo.id}
                            geo={geo}
                            colors={countries}
                            hoveredCountries={hoveredCountryCodes}
                        />
                    ))
                }
            </Geographies>
        </ComposableMap>
    );
};

export default Map;
